import React from "react"
import { TextField, Dialog, FlatButton, Snackbar } from "material-ui"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { IHolidayTemplate } from "../../models"
import DatesChip from "../common/DatesChip"
import * as utils from "../../helpers/utils"
import * as holidayHelper from "../../helpers/holidayHelper"
import AccountStore from "../../stores/AccountStore"
interface IProps {
  existingHolidayTemplates: IHolidayTemplate[]
  editHolidayTemplate: IHolidayTemplate
  handleClose(): void
  handleAdd(holidayTemplate: IHolidayTemplate): void
  handleUpdate(holidayTemplate: IHolidayTemplate): void
}
interface IState {
  name: string
  errorName: string
  hoursPerDay: number
  errorHoursPerDay: string
  dates: Date[]
  errorDates: string
  snackbarAlertContent: string
}

export default class AddHolidayTemplate extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      name: props.editHolidayTemplate ? props.editHolidayTemplate.Name : "",
      errorName: "",
      hoursPerDay: props.editHolidayTemplate ? props.editHolidayTemplate.HoursPerDay : 0,
      errorHoursPerDay: "",
      dates: props.editHolidayTemplate ? props.editHolidayTemplate.Dates : [],
      errorDates: "",
      snackbarAlertContent: ""
    }
    autobind(this)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.name.trim()) {
      this.setState({ errorName: strings.This_field_is_required })
      isValidate = false
    }
    else if (this.state.name.trim().length > 50) {
      this.setState({ errorName: strings.formatString(strings.This_field_must_be_less_than_x, 50) as string })
      isValidate = false
    }
    else if (this.props.existingHolidayTemplates.find(item => item.Name === this.state.name.trim() && (this.props.editHolidayTemplate ? item.Id !== this.props.editHolidayTemplate.Id : true))) {
      this.setState({ errorName: strings.Holiday_Template_name_is_duplicated })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }

    if (!this.state.hoursPerDay) {
      this.setState({ errorHoursPerDay: strings.This_field_is_required })
      isValidate = false
    }
    else if (Number.isNaN(Number(this.state.hoursPerDay))) {
      this.setState({ errorHoursPerDay: strings.Invalid_format })
      isValidate = false
    }
    else {
      let hoursPerDayMaxValue = 24
      if (this.props.editHolidayTemplate) {
        const linkedPayGroups = AccountStore.getCurrentAccount().PayGroups.filter(payGroup => payGroup.Holidays && payGroup.Holidays.find(holiday => holiday.HolidayTemplateId === this.props.editHolidayTemplate.Id))
        hoursPerDayMaxValue = linkedPayGroups.reduce((min, payGroup) => payGroup.PaySettings.MaximumPunchSetLength < min ? payGroup.PaySettings.MaximumPunchSetLength : min, 24)
      }

      if (Number(this.state.hoursPerDay) < 1 || Number(this.state.hoursPerDay) > hoursPerDayMaxValue) {
        this.setState({ errorHoursPerDay: strings.formatString(strings.This_field_requires_a_number_between_min_and_max, 1, hoursPerDayMaxValue) as string })
        isValidate = false
      }
      else {
        this.setState({ errorHoursPerDay: "" })
      }
    }

    if (!this.state.dates.length) {
      this.setState({ errorDates: strings.This_field_is_required })
      isValidate = false
    }
    else if (this.props.editHolidayTemplate && holidayHelper.checkDuplicatedDateForHolidayTemplate(this.props.editHolidayTemplate.Id, this.state.dates)) {
      this.setState({ errorDates: strings.Duplicated_date_exist_for_pay_group })
      isValidate = false
    }
    else {
      this.setState({ errorDates: "" })
    }
    return isValidate
  }

  handleSave() {
    if (!this.checkValidate()) return
    this.props.editHolidayTemplate ?
      this.props.handleUpdate({
        Id: this.props.editHolidayTemplate.Id,
        Name: this.state.name,
        HoursPerDay: this.state.hoursPerDay,
        Dates: this.state.dates
      }) :
      this.props.handleAdd({
        Id: utils.guid(),
        Name: this.state.name,
        HoursPerDay: this.state.hoursPerDay,
        Dates: this.state.dates
      })
  }

  render() {
    return (
      <div>
        <Dialog
          open={true}
          title={this.props.editHolidayTemplate ? `${strings.Edit_Holiday_Template} - ${this.props.editHolidayTemplate.Name}` : strings.Add_Holiday_Template}
          titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
          actions={
            <div>
              <FlatButton
                data-intercom-target={"menu-AccountSettings-PayConfiguration-HolidayTemplatesTab-Btn-CloseAddHolidaytemplateDialog"}
                label={strings.CANCEL}
                secondary={true}
                onTouchTap={this.props.handleClose}
              />
              <FlatButton
                data-intercom-target={"menu-AccountSettings-PayConfiguration-HolidayTemplatesTab-Btn-SaveHolidayTemplate"}
                label={strings.SAVE}
                primary={true}
                onTouchTap={this.handleSave}
              />
            </div>
          }
        >
          <hr />
          <div style={{ paddingLeft: 15, paddingRight: 15 }}>
            <TextField
              data-intercom-target={"menu-AccountSettings-PayConfiguration-HolidayTemplatesTab-Add-Entry-Name"}
              floatingLabelText={strings.Name}
              value={this.state.name}
              style={{ width: "95%" }}
              onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
              errorText={this.state.errorName}
              errorStyle={{ position: "absolute", bottom: -12 }}
            />
            <TextField
              data-intercom-target={"menu-AccountSettings-PayConfiguration-HolidayTemplatesTab-Add-Entry-HoursPerDay"}
              floatingLabelText={strings.Hours_Per_Day}
              value={this.state.hoursPerDay}
              onChange={(e, value) => this.setState({ hoursPerDay: value }, () => this.checkValidate())}
              errorText={this.state.errorHoursPerDay}
              errorStyle={{ position: "absolute", bottom: -12 }}
            />
            <div style={{ marginTop: 20 }}>
              <DatesChip
                title={strings.Dates}
                titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
                chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
                addButtonStyle={{ height: 40, marginTop: 2, marginLeft: -5, display: "inline-block" }}
                dates={this.state.dates}
                handleChange={dates => this.setState({ dates }, () => this.checkValidate())}
                error={this.state.errorDates}
                handleSnackbarAlertContent={snackbarAlertContent => this.setState({ snackbarAlertContent })}
              />
            </div>
          </div>
        </Dialog>
        <Snackbar
          open={this.state.snackbarAlertContent ? true : false}
          message={this.state.snackbarAlertContent}
          onRequestClose={() => this.setState({ snackbarAlertContent: "" })}
          autoHideDuration={3000}
          style={{ width: 500 }}
        />
      </div>
    )
  }
}